import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import {
  SquaresFour, ListChecks, Scales, WarningOctagon, Broadcast,
  UsersThree, Handshake, ChatCircleDots, SignOut, Eye, ShieldCheck, WaveSawtooth, Brain,
} from "@phosphor-icons/react";

const NAV = [
  { to: "/", label: "Command", icon: SquaresFour, testId: "nav-dashboard" },
  { to: "/tasks", label: "Tasks", icon: ListChecks, testId: "nav-tasks" },
  { to: "/decisions", label: "Decisions", icon: Scales, testId: "nav-decisions" },
  { to: "/risks", label: "Risks", icon: WarningOctagon, testId: "nav-risks" },
  { to: "/episodes", label: "Episodes", icon: Broadcast, testId: "nav-episodes" },
  { to: "/guests", label: "Guests", icon: UsersThree, testId: "nav-guests" },
  { to: "/sponsors", label: "Sponsors", icon: Handshake, testId: "nav-sponsors" },
  { to: "/relay", label: "The Curtain", icon: ChatCircleDots, testId: "nav-relay" },
  { to: "/rules", label: "Agent Rules", icon: ShieldCheck, testId: "nav-rules" },
  { to: "/voice", label: "Voice Lab", icon: WaveSawtooth, testId: "nav-voice" },
  { to: "/intake-lab", label: "Intake Lab", icon: Brain, testId: "nav-intake-lab" },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex" style={{ background: "var(--oz-page)" }}>
      {/* Sidebar */}
      <aside className="w-56 shrink-0 border-r border-[color:var(--oz-border)] flex flex-col" style={{ background: "var(--oz-card)" }}>
        <div className="p-4 border-b border-[color:var(--oz-border)]">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 flex items-center justify-center" style={{ background: "var(--oz-emerald)", color: "#fff" }}>
              <Eye size={16} weight="fill" />
            </div>
            <div>
              <div className="font-display text-sm font-semibold tracking-tight">The OZ Cast</div>
              <div className="overline" style={{ fontSize: 9 }}>AI · COO · v1</div>
            </div>
          </div>
        </div>

        <nav className="flex-1 py-2">
          {NAV.map(({ to, label, icon: Icon, testId }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              data-testid={testId}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 text-sm transition-colors ${
                  isActive
                    ? "text-[color:var(--oz-text)] bg-[color:var(--oz-hover)] border-l-2 border-[color:var(--oz-emerald)]"
                    : "text-[color:var(--oz-text-dim)] hover:text-[color:var(--oz-text)] hover:bg-[color:var(--oz-hover)] border-l-2 border-transparent"
                }`
              }
            >
              <Icon size={16} weight="regular" />
              <span className="font-display">{label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-[color:var(--oz-border)]">
          <div className="text-xs text-[color:var(--oz-text-dim)]">{user?.name}</div>
          <div className="text-[10px] text-[color:var(--oz-text-muted)] mb-3">{user?.role}</div>
          <button
            data-testid="logout-btn"
            onClick={logout}
            className="w-full flex items-center gap-2 text-xs text-[color:var(--oz-text-dim)] hover:text-[color:var(--oz-red)] transition-colors"
          >
            <SignOut size={14} /> Sign out
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 min-w-0 overflow-x-hidden relative z-10">
        {children}
      </main>
    </div>
  );
}
